import AccordionGroup from './AccordionGroup';
import Accordion from './Accordion';

export { Accordion, AccordionGroup };
